import './ChartLegend.css';
export var legendContainer = '_9x5f9b0-3-12-1';